<template>
  <b-row>
    <b-colxx xxs="12">
      <b-card class="mb-4" title="대표 옵션 설정">
        <b-table
          id="table-transition-example"
          :items="optionList"
          :fields="fields"
          primary-key="optionId"
          :tbody-transition-props="transProps"
          show-empty
        >
          <template v-slot:cell(selected)="row">
            <b-form-radio name="representativeId" @change="representativeOptionId(row.item.optionId)"></b-form-radio>
          </template>
          <template v-slot:cell(idx)="row">
            {{row.index + 1}}
          </template>
          <template v-slot:empty>
            <h4 style="text-align:center" class="mt-2">해당 옵션 목록이 없습니다.</h4>
          </template>
        </b-table>
        <b-row align-h="center">
<!--          <b-button variant="outline-primary" @click="goBack">뒤로</b-button>-->
          <b-button variant="primary" @click="onChange">저장</b-button>
        </b-row>
      </b-card>
    </b-colxx>
  </b-row>
</template>
<script>

  import api from '../../constants/api'

  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";

  import {
    validationMixin
  } from "vuelidate";

  const {
    required,
    maxLength,
    minLength,
    numeric,
    email
  } = require("vuelidate/lib/validators");

  export default {
    components: {
      'v-select': vSelect,
    },
    data() {
      return {
        transProps: {
          // Transition name
          name: 'list'
        },
        goodsId: this.$route.params.registerId,
        optionId: null,
        fields: [
          {key: 'selected', label: '대표설정'},
          {key: 'idx', label: '번호'},
          {key: 'optionId', label: '옵션코드'},
          {key: 'optionName', label: "옵션명"},
          {key: 'listPrice', label: "정상가"},
          {key: 'salePrice', label: "판매가"},
        ],
        optionList: [],
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },

    mounted() {
      this.loadData()
    },

    methods: {

      loadData() {

        this.optionList = []

        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.options)
        const params = {
          goodsId: this.goodsId
        }

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {

            res.data.data.options.forEach((val, idx) => {
              const option =
                {
                  optionId: val.optionId,
                  optionName: val.optionName,
                  listPrice: val.listPrice,
                  salePrice: val.salePrice,
                  saleStatus: val.onSale,
                  selected: false
                }

              this.optionList.push(option)
            });
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      },


      onChange() {
        if(this.optionId === null) {
          alert('대표로 설정 하실 옵션을 선택해주세요.')
          return false

        } else {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.goods.updateMainOption)
          const params = {
            goodsId: this.goodsId,
            mainOptionId: this.optionId
          }

          this.$http.post(reqURL, params ,{
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if(res.data.code === "OK") {
              
              alert("적용되었습니다. ")
              this.goBack()

            } else {
              throw 400
            }
          }).catch(err => {
            alert(err.response.data.message);

          })

        }
      },

      goBack() {
        this.$router.back()
      },

      representativeOptionId(optionId) {
        this.optionId = optionId
      }
    }
  }
</script>
<style>
  .list-move {
    transition: transform 1s;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(30px);
  }

  .table > tbody > tr > td {
    vertical-align: middle;
  }
</style>
